// 전역 토스트 — 디자인 시스템 sc-toast.
// 컴포넌트 밖(이벤트 핸들러·유틸)에서도 부를 수 있도록 모듈 수준 pub/sub으로 둔다.
let listeners = [];
let seq = 0;

export const subscribeToasts = (fn) => {
    listeners.push(fn);
    return () => {
        listeners = listeners.filter((l) => l !== fn);
    };
};

// 문구로 톤을 추정한다. 기존 alert() 호출부를 그대로 옮기기 위한 장치.
const inferTone = (message) => {
    const m = String(message);
    if (/실패|오류|에러|不|없습니다|불가|초과|잘못|취소되었|삭제/.test(m)) return "danger";
    if (/주의|확인해|입력해|선택해|동의|필요/.test(m)) return "warning";
    if (/성공|완료|되었습니다|축하|복사/.test(m)) return "success";
    return "info";
};

export const toast = (message, tone) => {
    const item = {
        id: ++seq,
        message: String(message),
        tone: tone || inferTone(message),
    };
    listeners.forEach((l) => l(item));
    return item.id;
};

toast.success = (m) => toast(m, "success");
toast.warning = (m) => toast(m, "warning");
toast.danger = (m) => toast(m, "danger");
toast.info = (m) => toast(m, "info");

export default toast;
